import { Button } from "@/components/ui/button";
import { MessageSquareDiff } from "lucide-react";
import { useNavigate } from "react-router-dom";

const id = "woxkWP";

export const openTallyPopup = (onClose?: () => void) => {
  // @ts-ignore
  window.Tally &&
    // @ts-ignore
    window.Tally.openPopup(id, {
      layout: "modal", // Open as a centered modal
      width: 700, // Set the width of the modal
      autoClose: 5000, // Close the popup 5 seconds after form was submitted (in ms)
      onClose,
    });
};

export const closeTallyPopup = () => {
  // @ts-ignore
  window.Tally &&
    // @ts-ignore
    window.Tally.closePopup(id);
};

export function RequestDualStakeButton() {
  const navigate = useNavigate();
  return (
    <Button variant="secondary" onClick={() => navigate("/dualSTAKE/request")}>
      <MessageSquareDiff />
      Request dualSTAKE Token
    </Button>
  );
}
